"use client";

import { motion, useReducedMotion } from "framer-motion";
import { Button } from "@/components/ui/button";
export default function Newsletter() {
  const prefersReducedMotion = useReducedMotion();
  const containerVariants = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: prefersReducedMotion ? 0 : 0.09
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: prefersReducedMotion ? 0 : 24
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: prefersReducedMotion ? 0 : 0.7,
        ease: [0.22, 1, 0.36, 1] as const
      }
    }
  };
  const cloudDriftLeft = prefersReducedMotion ? {} : {
    x: [0, 12, 0, -12, 0],
    y: [0, -6, 0, 6, 0]
  };
  const cloudDriftRight = prefersReducedMotion ? {} : {
    x: [0, -12, 0, 12, 0],
    y: [0, 6, 0, -6, 0]
  };
  return <section data-section-id="33414" id="join-our-community" data-nav="light" className="relative overflow-hidden bg-background py-24 md:py-40 dark bg-background text-foreground">
      <div aria-hidden="true" className="absolute inset-x-0 top-1/2 -translate-y-1/2 h-[75%] bg-secondary/20 ![padding:0px_0px_24px_0px]" />

      <motion.div aria-hidden="true" animate={cloudDriftLeft} transition={{
      duration: 14,
      repeat: Infinity,
      ease: "easeInOut"
    }} className="hidden md:block absolute left-4 lg:left-16 top-16 z-0 pointer-events-none">
        <svg width="140" height="80" viewBox="0 0 140 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M30 55 Q15 55 15 40 Q15 28 28 26 Q30 12 48 14 Q55 4 70 8 Q85 2 95 14 Q112 12 118 28 Q130 30 128 45 Q128 60 112 58 L30 58 Z" fill="hsl(36 50% 96%)" fillOpacity="0.95" />
        </svg>
      </motion.div>

      <motion.div aria-hidden="true" animate={cloudDriftRight} transition={{
      duration: 18,
      repeat: Infinity,
      ease: "easeInOut"
    }} className="hidden md:block absolute right-4 lg:right-16 bottom-16 z-0 pointer-events-none">
        <svg width="160" height="90" viewBox="0 0 160 90" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M35 62 Q18 62 18 46 Q18 32 32 30 Q35 14 55 16 Q64 4 80 8 Q98 2 110 16 Q128 14 135 32 Q150 34 148 52 Q148 68 130 66 L35 66 Z" fill="hsl(36 50% 96%)" fillOpacity="0.9" />
        </svg>
      </motion.div>

      <div className="relative z-10 mx-auto max-w-[940px] px-5 md:px-16">
        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.3
      }} className="mx-auto max-w-[640px] flex flex-col items-center text-center">
          <motion.div variants={itemVariants} className="mb-6">
            <svg width="72" height="60" viewBox="0 0 72 60" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="6" y="14" width="60" height="40" rx="4" fill="hsl(36 50% 96%)" stroke="hsl(268 42% 22%)" strokeWidth="1.75" />
              <path d="M6 18 L36 38 L66 18" stroke="hsl(268 42% 22%)" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" fill="none" />
              <path d="M14 6 Q28 10 36 6 Q44 2 58 6 Q52 12 44 10 Q36 14 28 10 Q20 14 14 6 Z" fill="hsl(158 55% 62%)" />
              <circle cx="60" cy="46" r="3" fill="hsl(20 88% 64%)" />
            </svg>
          </motion.div>

          <motion.h2 variants={itemVariants} className="mb-6 font-serif font-normal text-foreground" style={{
          fontSize: "clamp(2rem, 4vw, 3.5rem)",
          lineHeight: "1.08",
          letterSpacing: "-0.015em"
        }}>What Should <font color="#6cb6ef"><i>Screenado</i></font> Cover Next?</motion.h2>

          <motion.p variants={itemVariants} className="mb-4 text-lg text-muted-foreground max-w-[560px]" style={{
          lineHeight: "1.65"
        }}>See something your kids are watching that you don't quite understand? Have a question about screentime? Found a topic we should cover? We'd love to hear from you.</motion.p>

          <motion.p variants={itemVariants} className="mb-8 text-lg text-muted-foreground max-w-[560px]" style={{
          lineHeight: "1.65"
        }}>Send us your questions, suggestions, or feedback. You might even help us decide what we write about next. <br /><br />Leave us a note at Support@Screenado.com</motion.p>

          <motion.div variants={itemVariants}>
            <Button asChild size="lg" className="rounded-lg bg-primary font-bold text-primary-foreground hover:bg-primary/90 px-8 py-6 text-base shadow-sm">
              <a href="mailto:support@screenado.com">Talk to Screenado</a>
            </Button>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}